module.exports = __webpack_public_path__ + "img/store_background.855f245a.svg";